import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/LINK_CONTACT';
export const {action: showSimple} = createAction(`${domain}/SHOW_SIMPLE`, (institutionId, billPayer) => ({
    institutionId,
    billPayer,
}));

export const {
    action: searchRelation,
    success: searchRelationSuccess,
    failed: searchRelationFailed,
    aborted: searchRelationAborted,
} = createAction(`${domain}/SEARCH_RELATION`, (institutionId, term) => ({institutionId, term}));

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));

export const {action: selectionChanged} = createAction(`${domain}/SELECTION_CHANGED`, index => ({index}));

export const {
    action: updateSimple,
    success: updateSimpleSuccess,
    failed: updateSimpleFailed,
} = createAction(`${domain}/UPDATE_SIMPLE`, (institutionId, relationIds, billPayer) => ({
    institutionId,
    relationIds,
    billPayer,
}));

export const {
    action: fetchSuggestions,
    success: fetchSuggestionsSuccess,
    failed: fetchSuggestionsFailed,
} = createAction(
    `${domain}/FETCH_SUGGESTIONS`,
    (institutionId, billPayerId) => ({institutionId, billPayerId}),
    suggestions => ({suggestions}),
);
